import { QueryClient } from "react-query";

// Retries are disabled globally by default.
// Individual queries can opt-in to retries by passing retry config to useApiQuery.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false, // Opt-in only - individual queries can override
    },
  },
});
